@if (vm$ | async; as items) {
  @if (items.length) {
    <nav class="topbar">
      <ul class="topbar__list">
        @for (item of items; track item.route) {
          <li class="topbar__item" [class.topbar__item--active]="isMenuItemActive(item)">
            <a class="topbar__link" [routerLink]="item.route" [state]="navState(item)">
              <span class="topbar__icon">
                <img [src]="'../../../assets/icons/menu/' + item.icon + '.svg'" [alt]="item.label" />
              </span>
              <span class="topbar__label">{{ item.label }}</span>
            </a>
          </li>
        }
      </ul>
    </nav>
  }
}
